import { Link } from 'react-router-dom'
import type { Course } from '../../types'
import { coursePath } from './courseUtils'

const ACCESS: Record<Course['access'], string> = {
  free: 'Free',
  subscribers: 'For subscribers',
  paid: 'Not open yet',
}

const LEVEL: Record<string, string> = { beginner: 'Beginner', intermediate: 'Intermediate', advanced: 'Advanced', expert: 'Expert' }

/** A course as a card: title, who teaches it, who can join, level and students. */
const CourseCard = ({ course, dark = false }: { course: Course; dark?: boolean }) => (
  <Link
    to={coursePath(course.slug)}
    className={`block h-full rounded-xl border p-4 ${
      dark ? 'border-terminal-border bg-terminal-surface hover:bg-white/5' : 'border-gray-200 bg-white hover:bg-gray-50'
    }`}
    data-testid="course-card"
  >
    <span className={`font-semibold ${dark ? 'text-gray-100' : 'text-gray-900'}`}>{course.title}</span>
    {course.subtitle && <span className={`mt-0.5 block text-sm ${dark ? 'text-gray-400' : 'text-gray-600'}`}>{course.subtitle}</span>}
    <span className={`mt-2 block text-xs ${dark ? 'text-gray-500' : 'text-gray-500'}`}>
      {course.instructor_username ? `@${course.instructor_username} · ` : ''}
      {LEVEL[course.level] || course.level} · {course.enrollment_count} {course.enrollment_count === 1 ? 'student' : 'students'}
    </span>
    <span className="mt-1 block text-xs font-medium text-accent">{ACCESS[course.access]}</span>
  </Link>
)

export default CourseCard
